import React, { useEffect } from 'react'
import { Row, Col, Button, message, Spin, ConfigProvider } from 'antd'
import Cookies from 'js-cookie'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setUserInfo } from '@/redux/actions/commonActions'
import { getTokenByCode, getMac, getMacForPhone } from '@/services/login'
import { redirectURL } from '@/utils/authHelp'
import { hasCategoryPermission } from '@/annotations/nike-react'
import { formatMessageNew, defaultRoleList } from '@/utils/common'
import { messageModal } from '@/utils/modalUtils'
import { Base64 } from '@/utils/base64'
import SelectLang from '@/components/selectLang'
import _ from 'lodash'
import './Login.less'
const Login = () => {
  let userAgent = navigator.userAgent.toLowerCase()
  let isHasMobile = userAgent.includes('mobile')
  const dispatch = useDispatch()
  const spinLoading = useSelector(state => state.loadingStore.loading)
  const history = useHistory()
  const handleAuthenticate = () => {
    window.location.href = `${process.env.REACT_APP_OKTA_URL}${redirectURL}`
  }
  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search)
      const error_des = searchParams.get('error_description')
      const code = searchParams.get('code')
      if (error_des) {
        messageModal('error', { content: formatMessageNew('languageObj.loginLocale.oktaError') })
        return
      }
      if (code) {
        if (isHasMobile) {
          getMacForPhone({})
            .then(res => {
              loginFun(code, res.resultData)
            })
            .catch(err => {
              loginFun(code, null)
            })
        } else {
          getMac({})
            .then(res => {
              loginFun(code, res.resultData)
            })
            .catch(err => {
              loginFun(code, null)
            })
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const loginFun = (code, macId) => {
    const params = {
      code,
      mac: macId,
      redirectUrl: redirectURL
    }
    getTokenByCode(params).then(res => {
      if (res && res.resultData) {
        const info = res.resultData
        // 1: 正常登录，2：mac地址登录
        localStorage.setItem('nfc-auth-type', '1')
        Cookies.set('nfc-oauth-token', info.token)
        localStorage.setItem('nfcOauthIdToken', info.idToken || '')
        localStorage.setItem('userName', info.nickname)
        localStorage.setItem('account', info.nickname)
        let adminDefault = [
          {
            category: 'NFCANDRFID',
            permissionName: 'NFCANDRFID - Role management - Full Access',
            mappingName: 'menu_nfcAndRfid_roleManagement'
          },
          {
            category: 'NFCANDRFID',
            permissionName: 'NFCANDRFID - User management - Full Access',
            mappingName: 'menu_nfcAndRfid_userManagement'
          }
        ]
        // 不受控制菜单
        let uncontrolledMenu = [
          {
            category: '**',
            permissionName: '**',
            mappingName: '**'
          }
        ]
        info.permissions = info.permissions.concat(uncontrolledMenu)
        // 转换成小写
        info.roles = info.roles.map(item => item.toLowerCase())
        // 默认三个admin包含role,user
        if (_.intersection(defaultRoleList, info.roles).length > 0) {
          info.permissions = info.permissions.concat(adminDefault)
        }

        let localPermissions = info.permissions.map(item => {
          return item.mappingName
        })
        let localCategorys = info.permissions.map(item => {
          return item.category
        })
        // 完整的permission
        const permissionsCompleteInfoString = Base64.encode(JSON.stringify(info.permissions))
        const permissionsString = Base64.encode(JSON.stringify(localPermissions))
        const rolesString = Base64.encode(JSON.stringify(info.roles))
        const categorysString = Base64.encode(JSON.stringify(localCategorys))
        const workstationString = Base64.encode(JSON.stringify(info.workstation || ''))
        const macString = Base64.encode(JSON.stringify(macId || ''))
        localStorage.setItem('permissionsCompleteInfo', permissionsCompleteInfoString)
        localStorage.setItem('permissions', permissionsString)
        localStorage.setItem('roles', rolesString)
        localStorage.setItem('categorys', categorysString)
        localStorage.setItem('workstation', workstationString)
        localStorage.setItem('mac', macString)
        let partUserInfoObj = { ...info }
        delete partUserInfoObj.permissions
        delete partUserInfoObj.idToken
        delete partUserInfoObj.token
        delete partUserInfoObj.roles
        // 包含除permissions等的所有信息
        const partUserInfoString = Base64.encode(JSON.stringify(partUserInfoObj))
        localStorage.setItem('partUserInfo', partUserInfoString)
        let infoCommon = {
          userName: info.nickname,
          account: info.nickname,
          permissionsCompleteInfo: JSON.stringify(info.permissions),
          permissions: JSON.stringify(localPermissions),
          roles: JSON.stringify(info.roles),
          categorys: JSON.stringify(localCategorys),
          workstation: JSON.stringify(info.workstation),
          mac: JSON.stringify(macId),
          partUserInfo: JSON.stringify(partUserInfoObj)
        }
        dispatch(setUserInfo(infoCommon))
        let path = ''
        if (isHasMobile) {
          path = '/'
        } else {
          if (hasCategoryPermission('NFC')) {
            path = '/'
          } else {
            path = '/'
          }
        }
        history.push(path)
      } else {
        message.error('Login failed')
      }
    })
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 20,
          controlHeight: 40
        }
      }}
    >
      <Spin spinning={spinLoading} size="large" style={{ top: '50vh', transform: 'translateY(-50%)', zIndex: 10000 }}>
        <div className="login-page">
          <div className="langWrapper">
            <SelectLang />
          </div>
          <Row className="color-fader" type="flex" align="middle">
            <Col className="nike_zoom" style={{ width: 400, margin: '0 auto' }}>
              <div className="login-form">
                <div className="logo-wrapper">
                  <div className="login-form-logo">
                    <span className="nsg-glyph--swoosh" />
                  </div>
                </div>
                <div className="login-form-title" style={{ backgroundColor: 'rgba(131, 132, 132, 0.6)' }}>
                  <span>{formatMessageNew('languageObj.loginLocale.loginTitle')}</span>
                </div>
                <div className="login-form-body-item">
                  <Button
                    type="primary"
                    style={{ width: '100%', backgroundColor: 'rgba(22, 119, 255, 0.6)' }}
                    onClick={handleAuthenticate}
                  >
                    {formatMessageNew('languageObj.loginLocale.loginBtn')}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
    </ConfigProvider>
  )
}

export default Login
